module.exports = __webpack_public_path__ + "img/title.53e190bf.png";